import { styled, keyframes } from "@mui/material";
import { shouldNotForwardProps } from "../../../utils/shouldNotForwardProps.js";
const mapSizes = {
  sm: 3,
  md: 6
}, StyledLoaderContainer = styled(
  "div",
  shouldNotForwardProps(["size"])
)(({ theme, size = "md" }) => ({
  width: "100%",
  height: mapSizes[size],
  backgroundColor: theme.palette.secondary[500],
  position: "relative",
  overflow: "hidden"
})), StyledLoaderLine = styled("div")(({ theme }) => ({
  height: "100%",
  width: "40%",
  position: "absolute",
  backgroundColor: theme.palette.secondary[700],
  left: "-40%",
  animation: `${getAnimation()} 1.5s linear infinite`
})), getAnimation = () => keyframes`
    100% {
        left: 100%;
    }
`;
export {
  StyledLoaderContainer,
  StyledLoaderLine
};
//# sourceMappingURL=styles.js.map
